import { render, staticRenderFns } from "./MeditationBackground.vue?vue&type=template&id=3f9ff737&scoped=true&"
import script from "./MeditationBackground.vue?vue&type=script&lang=js&"
export * from "./MeditationBackground.vue?vue&type=script&lang=js&"
import style0 from "./MeditationBackground.vue?vue&type=style&index=0&id=3f9ff737&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ff737",
  null
  
)

export default component.exports